<template>

    <Page class="text-lg !max-w-[80%]">

        <div>
            <h2 class="text-xl font-semibold">Increase Your Car Parc</h2>
            <ul class="mt-1 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Carbucks REWARDS keeps customers engaged and encourages them to return for 
                    servicing — which means higher retention, more bookings, and more 
                    opportunities to deliver great service.
                </li>
            </ul>

            <h2 class="mt-6 text-xl font-semibold">New Revenue from Carbucks PROTECT Work Orders</h2>
            <ul class="mt-1 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    When customers request a work order through Carbucks PROTECT, your service 
                    department performs the work — and gets paid for it. That's extra service 
                    volume and pure profit without chasing new customers.
                </li>
            </ul>

            <h2 class="mt-6 text-xl font-semibold">Sell with Confidence</h2>
            <ul class="mt-1 list-disc text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Customers feel looked after when their issues (like worn brakes or tyres) 
                    are resolved quickly through Carbucks PROTECT — and that good experience 
                    happens in your workshop. It's a win for trust and loyalty.
                </li>
            </ul>
        </div>

    </Page>

</template>